import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { OrderApi } from "../../../../../../../../../../../services/Api/Organization/types";
import { OrderContext } from "../../../pages/Preview";
import OrderItemsCardTableBody from "./OrderItemsCardTableBody";

interface Props {
	fileImportPreviewMode?: boolean;
	importedOrder?: OrderApi;
}

const OrderItemsCardTable = ({ fileImportPreviewMode, importedOrder }: Props) => {
	const { t } = useTranslation();
	const { order } = useContext(OrderContext);
	const finalOrder = importedOrder ?? order;
	const isActionColumnShown = finalOrder.items.some((item) => item?.product_id || item?.linked_product?.id);

	return (
		<div className="table-responsive">
			<table className="table table-preview">
				<thead>
					<tr>
						<th className="action" />
						<th>{t("lib:common.word.name")}</th>
						<th>{t("common.word.volume")}</th>
						<th>{t("common.word.quantity")}</th>
						<th>{t("common.word.total_volume")}</th>
						<th>{t("common.word.item_cost")}</th>
						<th>{t("common.word.total_cost")}</th>
						<th className="w-15">{t("modules.order.field.sale_price_net_money.title")}</th>
						<th>
							{t("common.word.vat_rate")} <br />
							{t("common.word.vat")}
						</th>
						<th>{t("common.word.value")}</th>
						{isActionColumnShown && <th className="action" />}
					</tr>
				</thead>
				<OrderItemsCardTableBody fileImportPreviewMode={fileImportPreviewMode} importedOrder={importedOrder} />
			</table>
		</div>
	);
};

export default OrderItemsCardTable;
